module.exports = __webpack_public_path__ + "static/media/内页logo.c0cd7714.png";